import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EncDecData } from '../utilities/enc.dec';
import { environment } from '../../environments/environment';

// the following class intercepts an http request, before sending the request and after getting the response
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private _utility: EncDecData) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.encryptionEnabled) {
            // encrypting the request body before sending it
      if (req.method !== 'GET') {
        console.log(req);
        req = req.clone({ body: this._utility.encrypt(req.body) });
      }
    }
        // return next.handle(req);
    return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) { // checking whether the http event is a response event
                if (typeof (event.body) === 'string') {
                  if (environment.encryptionEnabled) {
                            // decrypting the response
                    event = event.clone({ body: JSON.parse(this._utility.decrypt(event.body)) });
                    console.log(event);
                  }
                }
              }
              return event;
            }));
  }
}
